<div class="checkout-dialog">
  <!-- Header -->
  <div class="checkout-header">
    <div class="d-flex align-items-center gap-2">
      <h2 class="mb-0">Checkout Order</h2>
    </div>
    <button mat-dialog-close mat-icon-button class="close-btn">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <!-- Content -->
  <div mat-dialog-content class="checkout-content">
    <div class="checkout-grid">
      <!-- Left Column - Receipt Preview Only -->
      <div class="receipt-column">
        <div class="receipt-header">
          <span nz-icon nzType="file-text" nzTheme="outline" class="section-icon"></span>
          <span class="section-title">Bill Preview</span>
        </div>
        <div id="print-section">
          <lib-bill-printer-section
            [data]="billPrinterData"
            [foodItemQuantity]="foodItemQuantity"
            [restaurantDetail]="restaurantDetail"
            [userName]="userName"
            [paymentTotals]="paymentTotals"
            [isPOS]="true">
          </lib-bill-printer-section>
        </div>
      </div>

      <!-- Right Column - All Functionality -->
      <div class="functionality-section">
        <form [formGroup]="billForm" class="functionality-form">
          <div formGroupName="orderBillRequest" class="form-body">
            <!-- Top Row: Payment Details & Numpad -->
            <div class="top-row">
              <!-- Payment Details -->
              <div class="payment-details">
                <div class="section-header">
                  <span nz-icon nzType="credit-card" nzTheme="outline" class="section-icon"></span>
                  <span class="section-title">Payment Details</span>
                </div>

                <!-- Discount -->
                <div class="form-group" formGroupName="discountDetail">
                  <label class="form-label">Discount</label>
                  <nz-input-group [nzPrefix]="discountIcon" [nzSuffix]="percentSuffix" class="discount-input">
                    <input nz-input
                      type="number"
                      formControlName="discountPercentage"
                      (input)="onDiscountAdded()"
                      placeholder="0 - 100.00"/>
                  </nz-input-group>
                  <ng-template #discountIcon>
                    <span nz-icon nzType="tag" nzTheme="outline" class="discount-icon-nz"></span>
                  </ng-template>
                  <ng-template #percentSuffix>
                    <span class="percent-suffix">%</span>
                  </ng-template>
                  @if (billForm.get('orderBillRequest.discountDetail.discountPercentage')?.errors?.['max']) {
                    <div class="error-text">
                      Maximum discount is 100.00
                    </div>
                  }
                </div>

                <!-- Payment Method -->
                <div class="form-group">
                  <div class="d-flex justify-content-between align-items-center mb-1">
                    <label class="form-label required-label mb-0">Payment Method</label>
                    <span class="keyboard-hint" style="font-size: 11px; color: #999;">Shift + ← → to navigate</span>
                  </div>
                  <div class="payment-methods" [class.has-error]="billForm.get('orderBillRequest.paymentMethod')?.touched && billForm.get('orderBillRequest.paymentMethod')?.invalid">
                    <!-- Cash -->
                    <button type="button"
                      class="payment-method-btn"
                      [class.selected]="billForm.get('orderBillRequest.paymentMethod')?.value === 1"
                      (click)="selectPaymentMethod(1)">
                      <span nz-icon nzType="wallet" nzTheme="outline" class="method-icon-nz"></span>
                      <span class="method-label">Cash</span>
                    </button>
                    <!-- Card -->
                    <button type="button"
                      class="payment-method-btn"
                      [class.selected]="billForm.get('orderBillRequest.paymentMethod')?.value === 2"
                      (click)="selectPaymentMethod(2)">
                      <span nz-icon nzType="credit-card" nzTheme="outline" class="method-icon-nz"></span>
                      <span class="method-label">Card</span>
                    </button>
                    <!-- Bank Transfer -->
                    <button type="button"
                      class="payment-method-btn"
                      [class.selected]="billForm.get('orderBillRequest.paymentMethod')?.value === 3"
                      (click)="selectPaymentMethod(3)">
                      <span nz-icon nzType="bank" nzTheme="outline" class="method-icon-nz"></span>
                      <span class="method-label">Bank Transfer</span>
                    </button>
                    <!-- Other -->
                    <button type="button"
                      class="payment-method-btn"
                      [class.selected]="billForm.get('orderBillRequest.paymentMethod')?.value === 4"
                      (click)="selectPaymentMethod(4)">
                      <span nz-icon nzType="ellipsis" nzTheme="outline" class="method-icon-nz"></span>
                      <span class="method-label">Other</span>
                    </button>
                    <!-- Uber -->
                    <button type="button"
                      class="payment-method-btn"
                      [class.selected]="billForm.get('orderBillRequest.paymentMethod')?.value === 5"
                      (click)="selectPaymentMethod(5)">
                      <span nz-icon nzType="car" nzTheme="outline" class="method-icon-nz"></span>
                      <span class="method-label">Uber</span>
                    </button>
                    <!-- PickMe -->
                    <button type="button"
                      class="payment-method-btn"
                      [class.selected]="billForm.get('orderBillRequest.paymentMethod')?.value === 6"
                      (click)="selectPaymentMethod(6)">
                      <span nz-icon nzType="car" nzTheme="outline" class="method-icon-nz"></span>
                      <span class="method-label">PickMe</span>
                    </button>
                  </div>
                  @if (billForm.get('orderBillRequest.paymentMethod')?.touched && billForm.get('orderBillRequest.paymentMethod')?.invalid) {
                    <div class="error-text">
                      Please select a payment method
                    </div>
                  }
                </div>

                <!-- Card Tax (only shown when Card is selected) -->
                @if (isCard) {
                  <div class="form-group">
                    <label class="form-label">Card Tax (%)</label>
                    <nz-input-number [nzMin]="0" class="w-100" (ngModelChange)="onCardTax()"
                    formControlName="cardTax" nzPlaceHolder="Enter card tax percentage"></nz-input-number>
                  </div>
                }

                <!-- Remark -->
                <div class="form-group">
                  <label class="form-label">Remark</label>
                  <textarea nz-input
                    formControlName="remarks"
                    placeholder="Add order notes..."
                    rows="2"
                  class="remark-input"></textarea>
                </div>

                <!-- Checkboxes -->
                <div class="checkbox-group">
                  <label nz-checkbox
                    [(ngModel)]="serviceChargeChecked"
                    [ngModelOptions]="{standalone: true}"
                    (ngModelChange)="updateCalculations()">
                    Service Charge
                  </label>
                  <label nz-checkbox
                    [(ngModel)]="taxChecked"
                    [ngModelOptions]="{standalone: true}"
                    (ngModelChange)="updateCalculations()">
                    Include Tax
                  </label>
                </div>
              </div>

              <!-- Numpad Section -->
              <div class="numpad-section">
                <div class="section-header">
                  <span nz-icon nzType="calculator" nzTheme="outline" class="section-icon"></span>
                  <span class="section-title">Amount Entry</span>
                </div>

                <!-- Net Amount Display -->
                <div class="net-amount-box">
                  <span class="net-amount-label">Net Amount</span>
                  <span class="net-amount-value">{{ grandTotal | number: '1.2-2' }}</span>
                </div>
                @if (discountAdded) {
                  <div class="discount-amount-box">
                    <span class="discount-amount-label">Discount</span>
                    <span class="discount-amount-value">{{ discount | number: '1.2-2' }}</span>
                  </div>
                }

                <label class="form-label required-label">Paid Amount</label>
                <div class="paid-amount-input-wrapper">
                  <input type="text"
                    #paidAmountInput
                    class="paid-amount-input"
                    [class.has-value]="paidAmountHasValue"
                    [class.has-error]="billForm.get('orderBillRequest.paidAmount')?.touched && billForm.get('orderBillRequest.paidAmount')?.invalid"
                    [value]="formattedPaidAmount"
                    (input)="onKeyboardInput($event)"
                    (blur)="billForm.get('orderBillRequest.paidAmount')?.markAsTouched()"
                    (keypress)="onPaidAmountKeyPress($event)"
                    placeholder="0"
                    inputmode="decimal"/>
                </div>
                @if (billForm.get('orderBillRequest.paidAmount')?.touched && billForm.get('orderBillRequest.paidAmount')?.invalid) {
                  <div class="error-text">
                    Please enter the paid amount
                  </div>
                }

                <!-- Balance Due -->
                <div class="balance-due">
                  <span class="balance-label">Balance Due:</span>
                  <span class="balance-value" [class.negative]="balance < 0" [class.positive]="balance >= 0">
                    {{ balance | number: '1.2-2' }}
                  </span>
                </div>

                <div class="numpad-grid">
                  <button type="button" class="numpad-btn" tabindex="-1" (click)="onNumpadClick('1')">1</button>
                  <button type="button" class="numpad-btn" tabindex="-1" (click)="onNumpadClick('2')">2</button>
                  <button type="button" class="numpad-btn" tabindex="-1" (click)="onNumpadClick('3')">3</button>
                  <button type="button" class="numpad-btn" tabindex="-1" (click)="onNumpadClick('4')">4</button>
                  <button type="button" class="numpad-btn" tabindex="-1" (click)="onNumpadClick('5')">5</button>
                  <button type="button" class="numpad-btn" tabindex="-1" (click)="onNumpadClick('6')">6</button>
                  <button type="button" class="numpad-btn" tabindex="-1" (click)="onNumpadClick('7')">7</button>
                  <button type="button" class="numpad-btn" tabindex="-1" (click)="onNumpadClick('8')">8</button>
                  <button type="button" class="numpad-btn" tabindex="-1" (click)="onNumpadClick('9')">9</button>
                  <button type="button" class="numpad-btn" tabindex="-1" (click)="onNumpadClick('.')">.</button>
                  <button type="button" class="numpad-btn" tabindex="-1" (click)="onNumpadClick('0')">0</button>
                  <button type="button" class="numpad-btn delete-btn" tabindex="-1" (click)="onNumpadDelete()">
                    <mat-icon>backspace</mat-icon>
                  </button>
                </div>
              </div>
            </div>

            <!-- Action Buttons (Desktop - inside content) -->
            <div class="action-buttons desktop-only mb-3">
              <button type="button" class="print-bill-btn"
                ngxPrint
                printSectionId="print-section"
                [useExistingCss]="true">
                <mat-icon>print</mat-icon>
                Print Bill
              </button>
              <button type="button" class="close-order-btn" [disabled]="submitting" (click)="onCloseOrder()">
                Close Order
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>

  <!-- Footer (Mobile/Tablet - fixed at bottom) -->
  <div mat-dialog-actions class="dialog-footer mobile-only">
    <button type="button" class="print-bill-btn"
      ngxPrint
      printSectionId="print-section"
      [useExistingCss]="true">
      <mat-icon>print</mat-icon>
      Print Bill
    </button>
    <button type="button" class="close-order-btn" [disabled]="submitting" (click)="onCloseOrder()">
      Close Order
    </button>
  </div>
</div>
